<ng-content select="[wdxAppContentMeta]"></ng-content>
<div class="app-content-body">
    <ng-content></ng-content>
</div>
